import TOGGLE_DRAWER from "../plugins/toggleDrawer"
import CURRENT_NAV from "../plugins/currentNav"
import LENRI_SLIDER from "../plugins/lenriSlider"
import PAGESCROLL from "../plugins/pagescroll"
import PAGETRANSITION from "../plugins/pagetransition"


const [ w, d, l ] = [ window, document, location ]

export default function INIT (){
  d.documentElement.classList.remove('no-js')
  PAGETRANSITION()
  d.documentElement.classList.add('is-loading')
  w.addEventListener('load',()=> d.documentElement.classList.remove('is-loading'))
  TOGGLE_DRAWER()
  LENRI_SLIDER({
    container: '[data-plugin="slider"]',
    prev: '[data-role="slider-prev"]',
    next: '[data-role="slider-next"]',
  })
  CURRENT_NAV('[data-plugin="currentNav"]')
  PAGESCROLL( l.pathname.replace(/^([^.]+\/)([^.]+)\.(php|html)/,'$1') == '/'? false: true )
}